var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inertia-link',{attrs:{"href":'/'}},[_c('img',{staticClass:"w-48 h-auto",attrs:{"src":"/assets/images/cetelec-logo.png","alt":"Cetelec services"}})])}
var staticRenderFns = []

export { render, staticRenderFns }